export function getStoredToken() {
  return (
    sessionStorage.getItem(
      "token"
    ) ||
    localStorage.getItem(
      "token"
    ) ||
    sessionStorage.getItem(
      "auth_token"
    ) ||
    localStorage.getItem(
      "auth_token"
    ) ||
    ""
  );
}

export function getStoredUser() {
  const candidates = [
    sessionStorage.getItem(
      "user"
    ),

    localStorage.getItem(
      "user"
    ),

    sessionStorage.getItem(
      "auth_user"
    ),

    localStorage.getItem(
      "auth_user"
    ),
  ];

  for (
    const raw of
    candidates
  ) {
    if (!raw) {
      continue;
    }

    try {
      const parsed =
        JSON.parse(
          raw
        );

      if (
        parsed &&
        typeof parsed ===
          "object"
      ) {
        return parsed;
      }
    } catch {
      // Try the next stored value.
    }
  }

  return null;
}

export function clearStoredAuth() {
  sessionStorage.removeItem(
    "token"
  );

  sessionStorage.removeItem(
    "user"
  );

  sessionStorage.removeItem(
    "auth_token"
  );

  sessionStorage.removeItem(
    "auth_user"
  );

  localStorage.removeItem(
    "token"
  );

  localStorage.removeItem(
    "user"
  );

  localStorage.removeItem(
    "auth_token"
  );

  localStorage.removeItem(
    "auth_user"
  );
}